export default __webpack_public_path__ + "static/media/iterativedesign-screenshot.666aaff8.png";